import { defaultFunction, getImage } from "@sushicorp/utils";
import { Image } from "artisn-ui-react";
import router from "next/router";
import React from "react";

import { defaultImageConfig } from "./AddToWishlistNotification.helpers";
import Styles from "./AddToWishlistNotification.styles";
import { AddToWishlistNotificationProps as Props } from "./AddToWishlistNotification.types";
import Button from "components/global/Button/Button";
import CONSTANTS from "config/constants";

const { PRODUCT_FALLBACK_IMAGE } = CONSTANTS.GENERAL;

const AddToWishlistNotification: React.FC<Props> = props => {
  const { className, product, onDelete = defaultFunction } = props;
  const { images, name } = product ?? {};

  const { url } = getImage(images, PRODUCT_FALLBACK_IMAGE);

  return (
    <Styles
      className={`AddToWishlistNotification ${className}`}
      showCloseIcon={false}
      onClick={() => router.push("/profile/wishlist")}
    >
      {images?.[0] ? (
        <Image
          image={url}
          config={defaultImageConfig}
          alt="Action icon"
          className="AddToWishlistNotification__image"
        />
      ) : null}
      <p className="AddToWishlistNotification__description">
        Se ha guardado: {name} en Favoritos
      </p>
      <Button
        className="AddToWishlistNotification__button"
        type="LINK"
        onClick={onDelete}
      >
        Eliminar
      </Button>
    </Styles>
  );
};

AddToWishlistNotification.defaultProps = {};

export default AddToWishlistNotification;
